import { Option } from '../../general-types';
import { ValueOfKey } from '../../utils-types';

export const BUSINESS_TYPE = {
  PERSONAL: 'PERSONAL',
  BUSINESS: 'BUSINESS',
} as const;

export type BusinessType = ValueOfKey<typeof BUSINESS_TYPE>;

export const businessTypeOptions: Option<BusinessType>[] = [
  { label: 'Personal', value: 'PERSONAL' },
  { label: 'Business', value: 'BUSINESS' },
];
